import React from 'react';
import rectangleBg from 'assets/images/background.svg';
import link_expire from 'assets/images/link_expire.gif';
import './ExpiredLink.css';

const ExpiredLink: React.FC = () => {
  return (
    <div
      style={{
        backgroundImage: `url(${rectangleBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        padding: '0px',
        marginTop: '-40px',
        minHeight: '100vh',
      }}
    >
      <div className="hipaa-wrapper success-page-wrapper">
        <div className="hipaa-card success-card">
          <div className="success-iconWrapper">
            <img src={link_expire} alt="Link expired" width={140} height={140} />
          </div>

          <h1 className="expired-link-title">
            This link has expired!
          </h1>

          <p className="expired-link-subtitle">
            The content you're looking for is no longer available or the link may have been removed.
          </p>

          <button className="submit-btn">
            <a
              href={`${window.location.origin}/patient`}
              className="text-white"
              target="_blank" 
              rel="noopener noreferrer"
            >
              Explore ChartRequest
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpiredLink;
